import React, { useEffect, useState } from 'react';
import { Button, Form, Grid, Header, Segment, Table, Icon, Modal, Input } from 'semantic-ui-react';
import Axios from 'axios';
import Constants from '../../../config/constants';
import { reactLocalStorage } from 'reactjs-localstorage';

const UsersPage = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    // Modal states
    const [userModalOpen, setUserModalOpen] = useState(false);
    const [resetModalOpen, setResetModalOpen] = useState(false);

    // Form fields state
    const [formUser, setFormUser] = useState({
        id: '',
        username: '',
        password: '',
        name: '',
        code: '',
        ward: '',
        resident: '',
        division: ''
    });
    const [newPassword, setNewPassword] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const token = reactLocalStorage.get('token');
            const res = await Axios.get(`http://${Constants.url}:${Constants.port}/v1/snr/users`, {
                headers: { Authorization: token }
            });
            if (res.data && res.data.code === 200) {
                setUsers(res.data.data);
            } else {
                console.error(res.data.message);
            }
        } catch (e) {
            console.error('Error fetching users:', e);
        }
        setLoading(false);
    };

    const handleOpenAddModal = () => {
        setIsEditMode(false);
        setFormUser({
            id: '',
            username: '',
            password: '',
            name: '',
            code: '',
            ward: '',
            resident: '',
            division: ''
        });
        setShowPassword(false);
        setUserModalOpen(true);
    };

    const handleOpenEditModal = (user) => {
        setIsEditMode(true);
        setFormUser({
            id: user.id,
            username: user.username,
            password: '',
            name: user.name || '',
            code: user.code || '',
            ward: user.ward || '',
            resident: user.resident || '',
            division: user.division || ''
        });
        setUserModalOpen(true);
    };

    const handleOpenResetModal = (user) => {
        setFormUser({ ...formUser, id: user.id, username: user.username });
        setNewPassword('');
        setShowNewPassword(false);
        setResetModalOpen(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormUser(prev => ({ ...prev, [name]: value }));
    };

    const isMediumPassword = (password) => {
        // At least 6 characters, containing both letters and numbers
        const regex = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;
        return regex.test(password);
    };

    const handleSaveUser = async () => {
        const token = reactLocalStorage.get('token');
        try {
            if (isEditMode) {
                // Update
                const { username, password, ...updateData } = formUser;
                const res = await Axios.put(`http://${Constants.url}:${Constants.port}/v1/snr/users/${formUser.id}`, updateData, {
                    headers: { Authorization: token }
                });
                if (res.data && res.data.code === 200) {
                    setUserModalOpen(false);
                    fetchUsers();
                } else {
                    alert(res.data.message || 'Error updating user');
                }
            } else {
                // Create
                if (!formUser.username || !formUser.password) {
                    alert('กรุณากรอก Username และ Password');
                    return;
                }
                if (!isMediumPassword(formUser.password)) {
                    alert('รหัสผ่านต้องมีความแข็งแกร่งระดับปานกลางขึ้นไป (อย่างน้อย 6 ตัวอักษร และประกอบด้วยตัวอักษรและตัวเลข)');
                    return;
                }
                const res = await Axios.post(`http://${Constants.url}:${Constants.port}/v1/snr/users`, formUser, {
                    headers: { Authorization: token }
                });
                if (res.data && (res.data.code === 200 || res.data.code === 201)) {
                    setUserModalOpen(false);
                    fetchUsers();
                } else {
                    alert(res.data.message || 'Error creating user');
                }
            }
        } catch (e) {
            console.error('Error saving user:', e);
            alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
        }
    };

    const handleResetPassword = async () => {
        if (!newPassword.trim()) {
            alert('กรุณากรอกรหัสผ่านใหม่');
            return;
        }
        if (!isMediumPassword(newPassword)) {
            alert('รหัสผ่านต้องมีความแข็งแกร่งระดับปานกลางขึ้นไป (อย่างน้อย 6 ตัวอักษร และประกอบด้วยตัวอักษรและตัวเลข)');
            return;
        }
        const token = reactLocalStorage.get('token');
        try {
            const res = await Axios.put(`http://${Constants.url}:${Constants.port}/v1/snr/users/${formUser.id}/reset-password`, {
                password: newPassword
            }, {
                headers: { Authorization: token }
            });
            if (res.data && res.data.code === 200) {
                setResetModalOpen(false);
                alert('รีเซ็ตรหัสผ่านสำเร็จ');
            } else {
                alert(res.data.message || 'Error resetting password');
            }
        } catch (e) {
            console.error('Error resetting password:', e);
            alert('เกิดข้อผิดพลาดในการรีเซ็ตรหัสผ่าน');
        }
    };

    const handleDeleteUser = async (id, name) => {
        if (name === 'admin') {
            alert('ไม่สามารถลบบัญชีผู้ดูแลระบบ (admin) ได้');
            return;
        }
        if (window.confirm(`ยืนยันการลบผู้ใช้ "${name}"?`)) {
            const token = reactLocalStorage.get('token');
            try {
                const res = await Axios.delete(`http://${Constants.url}:${Constants.port}/v1/snr/users/${id}`, {
                    headers: { Authorization: token }
                });
                if (res.data && res.data.code === 200) {
                    fetchUsers();
                } else {
                    alert(res.data.message || 'Error deleting user');
                }
            } catch (e) {
                console.error('Error deleting user:', e);
                alert('เกิดข้อผิดพลาดในการลบผู้ใช้');
            }
        }
    };

    return (
        <div style={{ display: 'flex', minHeight: '90vh', flexDirection: 'column' }}>
            <div style={{ flex: 1 }}>
                <Grid style={{ marginTop: '5.5em', padding: '0 30px' }}>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment color='teal' raised style={{ padding: '2em' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5em', borderBottom: '1px solid #eee', paddingBottom: '1em' }}>
                                    <Header as='h2' style={{ margin: 0 }}>
                                        <Icon name='users' color='teal' />
                                        <Header.Content>
                                            การจัดการผู้ใช้งาน
                                            <Header.Subheader style={{ marginTop: '0.25em' }}>User Management</Header.Subheader>
                                        </Header.Content>
                                    </Header>
                                    <Button color='green' onClick={handleOpenAddModal}>
                                        <Icon name='plus circle' /> เพิ่มผู้ใช้งานใหม่
                                    </Button>
                                </div>

                                <Table celled structured loading={loading}>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell style={{ width: '60px' }}>#</Table.HeaderCell>
                                            <Table.HeaderCell>Username</Table.HeaderCell>
                                            <Table.HeaderCell>ชื่อ-นามสกุล</Table.HeaderCell>
                                            <Table.HeaderCell style={{ width: '120px' }}>Code</Table.HeaderCell>
                                            <Table.HeaderCell>Ward</Table.HeaderCell>
                                            <Table.HeaderCell>Resident</Table.HeaderCell>
                                            <Table.HeaderCell>Division</Table.HeaderCell>
                                            <Table.HeaderCell style={{ width: '350px', textAlign: 'center' }}>การจัดการ</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        {users.map((user, index) => (
                                            <Table.Row key={user.id}>
                                                <Table.Cell>{index + 1}</Table.Cell>
                                                <Table.Cell>{user.username}</Table.Cell>
                                                <Table.Cell>{user.name}</Table.Cell>
                                                <Table.Cell>{user.code}</Table.Cell>
                                                <Table.Cell>{user.ward}</Table.Cell>
                                                <Table.Cell>{user.resident}</Table.Cell>
                                                <Table.Cell>{user.division}</Table.Cell>
                                                <Table.Cell style={{ textAlign: 'center' }}>
                                                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
                                                        <Button size='mini' color='blue' onClick={() => handleOpenEditModal(user)}>
                                                            <Icon name='edit' /> แก้ไข
                                                        </Button>
                                                        <Button size='mini' color='orange' onClick={() => handleOpenResetModal(user)}>
                                                            <Icon name='key' /> รหัสผ่าน
                                                        </Button>
                                                        <Button size='mini' color='red' onClick={() => handleDeleteUser(user.id, user.username)}>
                                                            <Icon name='trash' /> ลบ
                                                        </Button>
                                                    </div>
                                                </Table.Cell>
                                            </Table.Row>
                                        ))}
                                        {users.length === 0 && !loading && (
                                            <Table.Row>
                                                <Table.Cell colSpan='8' style={{ textAlign: 'center' }}>ไม่พบข้อมูลผู้ใช้งาน</Table.Cell>
                                            </Table.Row>
                                        )}
                                    </Table.Body>
                                </Table>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>

            {/* Add / Edit User Modal */}
            <Modal open={userModalOpen} onClose={() => setUserModalOpen(false)} size='small'>
                <Modal.Header>
                    <Icon name={isEditMode ? 'edit' : 'user plus'} /> {isEditMode ? 'แก้ไขข้อมูลผู้ใช้งาน' : 'เพิ่มผู้ใช้งานใหม่'}
                </Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Group widths='equal'>
                            <Form.Field required={!isEditMode}>
                                <label>Username</label>
                                <Input
                                    name='username'
                                    value={formUser.username}
                                    onChange={handleInputChange}
                                    placeholder='Username'
                                    disabled={isEditMode}
                                />
                            </Form.Field>
                            {!isEditMode && (
                                <Form.Field required>
                                    <label>Password</label>
                                    <Input
                                        type={showPassword ? 'text' : 'password'}
                                        icon={{
                                            name: showPassword ? 'eye slash' : 'eye',
                                            link: true,
                                            onClick: () => setShowPassword(!showPassword)
                                        }}
                                        name='password'
                                        value={formUser.password}
                                        onChange={handleInputChange}
                                        placeholder='Password'
                                    />
                                    <span style={{ fontSize: '0.85em', color: '#db2828', marginTop: '0.3em', display: 'block' }}>
                                        * ต้องมีความยาวอย่างน้อย 6 ตัวอักษร มีทั้งตัวอักษรและตัวเลขผสมกัน
                                    </span>
                                </Form.Field>
                            )}
                        </Form.Group>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <label>ชื่อ-นามสกุล</label>
                                <Input name='name' value={formUser.name} onChange={handleInputChange} placeholder='ชื่อ-นามสกุล' />
                            </Form.Field>
                            <Form.Field>
                                <label>Code (รหัสพนักงาน)</label>
                                <Input name='code' value={formUser.code} onChange={handleInputChange} placeholder='PMG9999' />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <label>Ward</label>
                                <Input name='ward' value={formUser.ward} onChange={handleInputChange} placeholder='เช่น AE01' />
                            </Form.Field>
                            <Form.Field>
                                <label>Resident</label>
                                <Input name='resident' value={formUser.resident} onChange={handleInputChange} placeholder='Resident' />
                            </Form.Field>
                            <Form.Field>
                                <label>Division</label>
                                <Input name='division' value={formUser.division} onChange={handleInputChange} placeholder='เช่น Trauma' />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setUserModalOpen(false)}>ยกเลิก</Button>
                    <Button color='green' onClick={handleSaveUser}>
                        <Icon name='save' /> บันทึก
                    </Button>
                </Modal.Actions>
            </Modal>

            {/* Reset Password Modal */}
            <Modal open={resetModalOpen} onClose={() => setResetModalOpen(false)} size='mini'>
                <Modal.Header>
                    <Icon name='key' /> รีเซ็ตรหัสผ่านสำหรับ: {formUser.username}
                </Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Field required>
                            <label>รหัสผ่านใหม่</label>
                            <Input
                                type={showNewPassword ? 'text' : 'password'}
                                icon={{
                                    name: showNewPassword ? 'eye slash' : 'eye',
                                    link: true,
                                    onClick: () => setShowNewPassword(!showNewPassword)
                                }}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder='รหัสผ่านใหม่'
                            />
                            <span style={{ fontSize: '0.85em', color: '#db2828', marginTop: '0.3em', display: 'block' }}>
                                * รหัสผ่านระดับปานกลาง (Medium): ต้องมีความยาวอย่างน้อย 6 ตัวอักษร มีทั้งตัวอักษรและตัวเลขผสมกัน
                            </span>
                        </Form.Field>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setResetModalOpen(false)}>ยกเลิก</Button>
                    <Button color='orange' onClick={handleResetPassword}>
                        <Icon name='check' /> ยืนยันรีเซ็ต
                    </Button>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default UsersPage;
